// extracted by mini-css-extract-plugin
module.exports = {"container":"PublicPageLayout_container__SbSjL","header":"PublicPageLayout_header__sgjBP","body":"PublicPageLayout_body__3KxOy","content":"PublicPageLayout_content__Sfyh3"};